import { useZero } from "@rocicorp/zero/react";
import { sharedMutators } from "../../shared/mutators";
import { useHasAccess } from "../hooks/useHasAccess";
import { routes, useCurrentUrl } from "../lib/urls";
import { Banner } from "./Banner";
import { Button } from "./Button";
import type { BranchData } from "./Workflow";

type Props = {
  branch: BranchData;
};

export function DeletedOnBranchBanner({ branch }: Props) {
  const z = useZero();
  const { spaceId } = useCurrentUrl(routes.space.workflow);
  const canRestore = useHasAccess("space:write", spaceId);

  return (
    <Banner
      actions={
        canRestore ? (
          <Button
            icon="rotate-ccw"
            onClick={() =>
              z.mutate(
                sharedMutators.restoreWorkflowOnBranch({ branchId: branch.id })
              )
            }
          >
            Undelete
          </Button>
        ) : undefined
      }
    >
      This workflow was deleted on this branch
    </Banner>
  );
}
